export const USER_TYPE_BUSINESS = "business"
export const VALID_USER_TYPES = ["business","staff"]

/**
 * Functional logic to process the user data store of the `/me` api
 * and return access or not:
 * @param userPermissions `(Array[Object]):` `$store.auth.currentUser.permissions` the permissions
 * list of the current user
 * @param validPermissions `(Array[Integer]):` reference to one of the constants defined in this file
 * for the given action, i.e. create a new project requires `PROJECTS_EDIT` values to exist in `userPermissions`
 * @param userType `(String):` `$store.auth.currentUser.login_as` user type
 * @return true: when the user is either a `business owner` or the user has the permissions
 * @return false: otherwise
 */
export function doesUserHavePermission(userPermissions, validPermissions, userType){
  if(userType === USER_TYPE_BUSINESS){
    return true
  }else if(!validPermissions || !userPermissions){
    // invalidate if either expected or actual is not truthy
    return false
  } else if (VALID_USER_TYPES.includes(userType)){
    let retval = true
    validPermissions.forEach(function(permissionKey){
      retval = retval && (!! userPermissions.filter( el => el.id === permissionKey).length)
    })
    return !!retval
  }else{
    return false
  }
}

/**
 * Wrapper function to suppport group validations for use with validating tab-entrie; i.e. projects-tabs
 * @param userPermissions `(Array[Object]):` `$store.auth.currentUser.permissions` the permissions
 * list of the current user
 * @param validPermissions `(Array[Array[Integer]]):` Collection of references to one of the constants defined in this file
 * for the given action, i.e. create a new project requires `PROJECTS_EDIT` values to exist in `userPermissions`
 * @param userType `(String):` `$store.auth.currentUser.login_as` user type
 * @return true: when the user is either a `business owner` or the user has the permissions
 * @return false: otherwise
 */
export function doesUserHavePermissionOfAnySet(userPermissions, validPermissionsSet, userType){
  if(userType === USER_TYPE_BUSINESS){
    return true
  }else if(!validPermissionsSet || !userPermissions){
    // invalidate if either expected or actual is not truthy
    return false
  } else if (VALID_USER_TYPES.includes(userType)){
    let retval = false
    validPermissionsSet.forEach(function(permissionSet){
      retval = retval || doesUserHavePermission(userPermissions, permissionSet, userType)
    })
    return !!retval
  }else{
    return false
  }
}

// Bussiness User Only
export const BUSINESSES_OWNER_ONLY = [-2]

// Admin
export const PROJECTS_ADMIN = [902]
export const IPO_ADMIN = [903]
export const RETURNS_ADMIN = [904]
export const STOCK_TRANSFERS_ADMIN = [905]

// Customers
export const CUSTOMERS_VIEW = [42]
export const CUSTOMERS_EDIT = [42,43]
export const CUSTOMERS_IMPORT = [42,43,45]
export const CUSTOMERS_EXPORT = [42,43,46]
export const CUSTOMERS_CREATED_PROJECT = [42,48]
// Customer-Globals
export const CUSTOMERS_VIEW_ANY = [CUSTOMERS_VIEW]


// Stocks
export const STOCKS_VIEW = [52]
export const STOCKS_EDIT = [52, 53]

export const MANUFACTURED_VIEW = [61]
export const MANUFACTURED_EDIT = [61, 62]

export const TRANSFERS_VIEW = [71]
export const TRANSFERS_EDIT = [71, 72]

export const INBOUND_VIEW = [81]
export const INBOUND_EDIT = [81, 82]

export const OUTBOUND_VIEW = [91]
export const OUTBOUND_EDIT = [91, 92]

// Stock-Globals
export const STOCKS_VIEW_ANY = [STOCKS_VIEW, MANUFACTURED_VIEW, TRANSFERS_VIEW, INBOUND_VIEW, OUTBOUND_VIEW, STOCK_TRANSFERS_ADMIN]

// Suppliers
export const SUPPLIERS_VIEW = [121]
// Supplier-Globals
export const SUPPLIERS_VIEW_ANY = [SUPPLIERS_VIEW]


// Financiers
export const FINANCIERS_VIEW = [32]
export const FINANCIERS_EDIT = [32,33]
export const FINANCIERS_EXPORT = [32,33,35]
export const FINANCIERS_IMPORT = [32,33,36]
// Financier-Globals
export const FINANCIERS_VIEW_ANY = [FINANCIERS_VIEW, FINANCIERS_EDIT, FINANCIERS_EXPORT, FINANCIERS_IMPORT]


// Businesses
export const BUSINESSES_VIEW = [3]
export const BUSINESSES_EDIT = [3,4]
// Business-Globals
export const BUSINESSES_VIEW_ANY = [BUSINESSES_VIEW]

// Branches
export const BRANCHES_VIEW = [14]
export const BRANCHES_EDIT = [15]
export const BRANCHES_EXPORT = [18]
export const BRANCHES_IMPORT = [19]

// warehouses
export const WAREHOUSES_VIEW = [1004]
export const WAREHOUSES_EDIT = [1004, 1005]
export const WAREHOUSES_DELETE = [1004, 1005, 1006]
export const WAREHOUSES_EXPORT = [1004, 1007]
export const WAREHOUSES_IMPORT = [1004, 1005, 1006, 1008]


// Staff
export const STAFF_VIEW = [6]
export const STAFF_EDIT = [6,7]
export const STAFF_EXPORT = [6,7,11]
export const STAFF_IMPORT = [6,7,12]

// Roles
export const ROLES_VIEW = [21]
export const ROLES_EDIT = [21,22]
export const ROLES_EXPORT = [21,22,25]


// IPO
export const INTERNAL_PO_VIEW = [502]
export const INTERNAL_PO_EDIT = [502,503]
export const INTERNAL_PO_DELETE = [502,503,504]
// IPO-Globals
export const INTERNAL_PO_VIEW_ANY = [INTERNAL_PO_VIEW, IPO_ADMIN]


// Projects
export const PROJECTS_VIEW = [320]
export const PROJECTS_EDIT = [320,321]
export const PROJECTS_DELETE = [320,321,323]
// Projects-Quotes
export const QUOTES_VIEW = [340]
export const QUOTES_EDIT = [340,341]
export const QUOTES_DELETE = [340,341,343]
// Projects-SaleOrders
export const SALES_VIEW = [351]
export const SALES_EDIT = [351,352]
export const SALES_DELETE = [351,352,353] // Custom-Edit
export const SALES_PURCHASER = [351,356] // is this --> PO Manager
// Projects-Purchases
export const PURCHASES_VIEW = [371]
export const PURCHASES_EDIT = [371,372]
export const PURCHASES_DELETE = [371,372,374]
// Projects-Invoices
export const INVOICES_VIEW = [391]
export const INVOICES_EDIT = [391,392]
export const INVOICES_DELETE = [391,392,394]
// Projects-Globals
export const PROJECTS_VIEW_ANY = [PROJECTS_VIEW, QUOTES_VIEW, SALES_VIEW, PURCHASES_VIEW, INVOICES_VIEW, PROJECTS_ADMIN]

// Returns
export const RETURNS_VIEW = [522]
export const RETURNS_EDIT = [522,523]
export const RETURNS_DELETE = [522,523,524]
export const RETURNS_VIEW_ANY = [RETURNS_VIEW, RETURNS_EDIT, RETURNS_DELETE, RETURNS_ADMIN]

// Xero
export const XERO_CONFIGURE = [1002]
